/**
 *
 * Checks for equality of 2 strings or numbers, ignoring their case.
 *
 * Examples:
 * - equals('FooBar', 'fooBAR') returns true
 * - equals(15, '15') returns true
 *
 */
export const equalsIgnoreCase = (stringA: string|number, stringB: string|number) =>
  String(stringA).toLowerCase() === String(stringB).toLowerCase()
